var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"45px !important"},attrs:{"src":require("@/assets/images/app/logo_heyway_koksgrå_rgb.png"),"alt":"Logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }